import { cn, Typography } from "@kyan/ui";
import { type ReactNode } from "react";

export interface TradeOptionProps {
  title: string;
  description: ReactNode;
  checked: boolean;
  badge?: ReactNode;
  onClick: () => void;
}

export const TradeOption: React.FC<TradeOptionProps> = ({
  title,
  badge,
  description,
  checked,
  onClick,
}) => {
  return (
    <button
      className={cn(
        "cursor-pointer rounded-lg border-2 border-transparent p-6 text-left transition-colors",
        {
          "bg-buttonFill": !checked,
          "border-primary": checked,
        },
      )}
      onClick={onClick}
    >
      <div className="mb-4 flex items-center gap-3">
        <span
          className={cn(
            "border-primary flex items-center rounded-full border p-1 transition-colors",
            {
              "border-textSecondary": !checked,
            },
          )}
        >
          <span
            className={cn("bg-primary size-4 rounded-full transition-colors", {
              "bg-transparent": !checked,
            })}
          />
        </span>
        <Typography weight="medium" variant="primary">
          {title}
        </Typography>
        {badge && (
          <span className="ml-auto flex gap-1 rounded-xl bg-[linear-gradient(91deg,#FFF_-31.93%,#3550FC_-31.92%,#9054FF_101.4%)] px-2 py-1 text-xs text-white">
            {badge}
          </span>
        )}
      </div>
      <Typography>{description}</Typography>
    </button>
  );
};
